import { skedApi } from "../_skedApi";

export interface ReplaceAssetRequest {
  originalAssetId: string;
  replacementAssetId: string;
}

export async function replaceAsset(
  inboxId: string,
  request: ReplaceAssetRequest
): Promise<void> {
  await skedApi.post(`/content-inbox/inbox/${inboxId}/assets/replace`, request);
}
